import { Document, Page, pdfjs } from "react-pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

//TODO try to fix file.data problem with txt files(Might be executed) reove src={file.data} with preview image
const DocumentImage = ({ file, style }) => {
  let header = file.header["content-type"];

  //THIS URL can be used for the downloadlink. Needs to be modified for non PDFs to get the real document instead of the Preview
  let url = URL.createObjectURL(file.data);
  switch (true) {
    case header?.startsWith("image/"):
      return (
        <img
          src={url}
          className="img-fluid"
          style={style ? style : { width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      );

    case header === "application/pdf":
      return (
        <div style={style ? style : { width: "100%", maxHeight: "250px", marginTop: "10px", marginBottom: "10px"}}>
          <Document file={file.data}>
            <Page pageNumber={1} onRenderError={() => {}} />
          </Document>
        </div>
      );

    default:
      return "";
  }
};

export default DocumentImage;
